import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from 'theme/withStyles';
import iconError from 'icons/icon-error.svg';
import ErrorMsg from 'common/ErrorMsg';
import RawHtml from '../common/RawHtml';

import rootStyles from './styles/root';

const styles = (theme) => {
  const common = {
    root: rootStyles(theme),
  };
  return {
    ...common,
    errorImage: {
      display: 'none',
    },
    h1: {
      ...theme.typography.h1,
      '& *': {
        display: 'inline',
        margin: 0,
        padding: 0,
      },
      background: `url(${iconError}) 50% 0 no-repeat`,
      fontSize: 36,
      marginBottom: theme.spacing.xs,
      paddingTop: 140,
      textTransform: 'uppercase',
    },
    h2: {
      '& *': {
        display: 'inline',
        margin: 0,
        padding: 0,
      },
    },
    root: {
      ...common.root,
      textAlign: 'center',
    },
  };
};

export const ErrorBare = ({
  classes,
  clientEmail,
  clientPhone,
  clientWeb,
  errorSubtext,
  errorTitle,
  helpSubtext,
  helpTitle,
}) => (
  <section>
    <div className={classnames('error-view', classes.root)}>
      <div className="row">
        <div className="widget">
          <RawHtml type="h1" className={classes.h1}>
            {errorTitle}
          </RawHtml>
          <RawHtml type="h2" className={classes.h2}>
            {errorSubtext}
          </RawHtml>
          <ErrorMsg type="page" />
          <img src="/oao/images/error.png" alt="Error" className={classes.errorImage} />
          <RawHtml type="h3">{helpTitle}</RawHtml>
          <RawHtml>{helpSubtext}</RawHtml>
          <p>
            <RawHtml type="a" href={`tel:${clientPhone}`}>
              {clientPhone}
            </RawHtml>{' '}
            <span>|</span>{' '}
            <RawHtml type="a" href={`mailto:${clientEmail}`}>
              {clientEmail}
            </RawHtml>{' '}
            <span>|</span>{' '}
            <RawHtml type="a" href={clientWeb}>
              {clientWeb}
            </RawHtml>
          </p>
        </div>
      </div>
    </div>
  </section>
);

ErrorBare.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  clientEmail: PropTypes.string,
  clientPhone: PropTypes.string,
  clientWeb: PropTypes.string,
  errorSubtext: PropTypes.string,
  errorTitle: PropTypes.string,
  helpSubtext: PropTypes.string,
  helpTitle: PropTypes.string,
};

ErrorBare.defaultProps = {
  clientEmail: null,
  clientPhone: null,
  clientWeb: null,
  errorSubtext: null,
  errorTitle: null,
  helpSubtext: null,
  helpTitle: null,
};

const mapStateToProps = ({ page, session }) => ({
  clientEmail: session.data.clientEmail,
  clientPhone: session.data.clientPhone,
  clientWeb: session.data.clientWeb,
  errorMsg: page.error && page.errorMsg,
  errorSubtext: session.meta.error.errorSubtext,
  errorTitle: session.meta.error.errorTitle,
  helpSubtext: session.meta.error.helpSubtext,
  helpTitle: session.meta.error.helpTitle,
});

const ErrorStyled = withStyles(styles)(ErrorBare);

export default connect(mapStateToProps)(ErrorStyled);
